import {
  Typography,
  CardContent,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Switch,
  Chip,
  IconButton,
} from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import { QuantityInput } from "../../../../../../../components/BaseInputs/QuantityInput";
import { Controller, useFormContext } from "react-hook-form";
import { useQuery } from "react-query";
import axiosClient from "../../../../../../../lib/axios";
import { useState } from "react";
import DialogSelecionarProdutoOcs from "./DialogSelecionarProdutoOcs";
import SkeletonCardProdutos from "./SkeletonCardProdutos";

export default function CardProdutos() {

  //formulario
  const { getValues, setValue, watch, control } = useFormContext()
  const notaFiscal = getValues("notaFiscal")

  const [openDialogSelecionarProduto, setOpenDialogSelecionarProduto] = useState<IDataProdutoNF | null>(null);

  //querys e mutations 
  const { isLoading } = useQuery({
    queryKey: ["detalhar-nota-fiscal"],
    queryFn: () =>
      axiosClient.get(`/estoque/entrada-mercadorias/detalhar-nota-fiscal/${notaFiscal.id}`),
    cacheTime: 0,
    staleTime: 0,
    onSuccess: (data) => {
      setValue("produtosNF", data?.data || [])
    },
  });

  if (isLoading) {
    return <SkeletonCardProdutos />;
  }

  return (
    <>
      <CardContent>
        <Box sx={{ overflow: "auto" }}>
          <Table size="small" sx={{ borderCollapse: 'collapse' }}>
            <TableHead sx={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff' }}>
              <TableRow>
                <TableCell colSpan={4} sx={{ borderBottom: 'none', pb: 0, whiteSpace: 'nowrap', backgroundColor: '#fff' }}>
                  <Typography variant="h6" component="h2">
                    Produtos da NF
                  </Typography>
                </TableCell>
                <TableCell colSpan={5} sx={{ borderBottom: 'none', pb: 0, borderLeft: '1px solid #e0e0e0', whiteSpace: 'nowrap', backgroundColor: '#fff' }}>
                  <Typography variant="h6" component="h2">
                    Produtos da OC
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ whiteSpace: 'nowrap', backgroundColor: '#fff' }}><b>Produto</b></TableCell>
                <TableCell align="center" sx={{ whiteSpace: 'nowrap', backgroundColor: '#fff' }}><b>Quantidade</b></TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap', backgroundColor: '#fff' }}><b>Lote</b></TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap', backgroundColor: '#fff' }}></TableCell>
                <TableCell sx={{ borderLeft: '1px solid #e0e0e0', whiteSpace: 'nowrap', backgroundColor: '#fff' }}><b>Código da OC</b></TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap', backgroundColor: '#fff' }}><b>Produto comprado</b></TableCell>
                <TableCell align="right" sx={{ whiteSpace: 'nowrap', backgroundColor: '#fff' }}><b>Quantidade</b></TableCell>
                <TableCell align="right" sx={{ whiteSpace: 'nowrap', backgroundColor: '#fff' }}><b>Valor</b></TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap', backgroundColor: '#fff' }}><b>Status</b></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {watch('produtosNF').map((produto: IDataProdutoNF, index: number) => (
                <TableRow key={produto.nf_item_id} sx={{ '& td': { minHeight: '60px', height: '60px' }, '&:last-child td, &:last-child th': { border: 0 } }}>
                  {/* Produtos da NF */}
                  <TableCell>
                    <Typography variant="caption">
                      {produto.nf_produto}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Controller
                      name={`produtosNF.${index}.quantidade_recebida`}
                      control={control}
                      render={({ field }) => (
                        <QuantityInput
                          width={'100px'}
                          label={produto.nf_unidade_medida ?? undefined}
                          value={`${field.value}`}
                          onChange={(newValue) => {
                            field.onChange(newValue);
                           }}
                        />
                      )}
                    />
                  </TableCell>
                  <TableCell >{produto.nf_lote ?? 'N/A'}</TableCell>
                  <TableCell sx={{ borderRight: '1px solid #e0e0e0' }}>
                    <Controller
                      name={`produtosNF.${index}.recebido`}
                      control={control}
                      render={({ field }) => (
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                          <Switch
                            checked={field.value}
                            onChange={(_, checked) => field.onChange(checked)}
                            size="small"
                          />
                          <Typography variant="caption" color="text.secondary">
                            Recebido
                          </Typography>
                        </Box>
                      )}
                    />
                  </TableCell>
                  
                  {/* Produtos da OC */}
                  <TableCell sx={{ borderLeft: '1px solid #e0e0e0' }}>
                    <Typography variant="caption">
                      {produto.numero_ordem_compra ?? '-'}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="caption">
                      {produto.oc_nome_produto ?? '-'}
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography variant="caption">
                      {produto.oc_quantidade ?? '-'} {produto.oc_unidade_medida ?? ""}
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography variant="caption">
                      {produto.oc_valor ? `R$ ${produto.oc_valor.toString().replace('.', ',')}` : '-'}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <Chip
                        label={produto.status}
                        size="small"
                        color={produto.status === "Encontrado" ? "success" : "error"}
                        variant="filled"
                      />
                      <IconButton
                        size="small"
                        onClick={() => setOpenDialogSelecionarProduto(produto)}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </CardContent>
      {
        openDialogSelecionarProduto &&
        <DialogSelecionarProdutoOcs
          open={Boolean(openDialogSelecionarProduto)}
          produto={openDialogSelecionarProduto}
          onClose={() => setOpenDialogSelecionarProduto(null)}
        />
      }
    </>
  );
}

export interface IDataProdutoNF {
  nf_item_id: number;
  recebido: boolean;
  nf_produto: string;
  nf_quantidade: string;
  quantidade_recebida: string;
  ordem_compra_item_id: string | null;
  oc_nome_produto: string;
  numero_ordem_compra: string;
  oc_valor: number;
  oc_quantidade: string;
  status: "Encontrado" | "Não encontrado";
  nf_unidade_medida: string | null;
  oc_unidade_medida: string | null;
  motivo?: string;
  nf_lote: string | null;
  nf_data_validade_lote: string | null;
  nf_data_fabricacao_lote: string | null;
}